export default __webpack_public_path__ + "static/SR USA - Vegano - Declaración-25ec0079d233213accdcb351d9f74d92.pdf";